export interface ProcessType {
  title: string;
  descriptions: string[];
}

export const PROCESSES = [
  {
    title: "문의 접수",
    descriptions: [],
  },
  {
    title: "사전 미팅",
    descriptions: ["JD 공유", "요구사항 정리", "일정 협의"],
  },
  {
    title: "서비스 계약",
    descriptions: ["상품 선정", "세부사항 확정", "계약서 작성"],
  },
  {
    title: "AI 소싱",
    descriptions: ["후보자 발굴", "적합성 검증", "프로필 분석"],
  },
  {
    title: "리스트 전달",
    descriptions: ["인사이트 공유", "추천 순위", "상세 리포트"],
  },
  {
    title: "후속 지원",
    descriptions: ["피드백 수렴", "지속적 소통", "맞춤형 대응"],
  },
];
